const defaultTheme = {
  backgroundColour: "#fffaf0",
  primaryColour: "#ea0101",
}

export default defaultTheme
